import { render, staticRenderFns } from "./ns-orders-product-quantity.vue?vue&type=template&id=42be7c3b&"
import script from "./ns-orders-product-quantity.vue?vue&type=script&lang=js&"
export * from "./ns-orders-product-quantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports